import { MagnifyingGlassIcon, PlusIcon } from '@heroicons/react/24/outline';

interface NotesHeaderProps {
    searchQuery: string;
    onSearchQueryChange: (query: string) => void;
    onAddNote: () => void;
}

/**
 * Panel header strip for the Notes tab — an inline client-side search input
 * and the "Add note" action (the note count lives on the tab label itself).
 * Matches the bordered header pattern used by the other overview tabs
 * (Files, Monitoring).
 */
function NotesHeader({ searchQuery, onSearchQueryChange, onAddNote }: NotesHeaderProps) {
    return (
        <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-gray-200 flex-shrink-0">
            <div className="flex items-center gap-4 min-w-0">
                <div className="flex items-center gap-2 w-[360px] max-w-full h-9 bg-gray-50 border border-gray-200 rounded-lg px-3">
                    <MagnifyingGlassIcon className="w-4 h-4 text-gray-400 flex-shrink-0" />
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={(event) => onSearchQueryChange(event.target.value)}
                        placeholder="Search notes..."
                        aria-label="Search notes"
                        className="w-full bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400 font-inter"
                    />
                </div>
            </div>

            <button
                type="button"
                onClick={onAddNote}
                className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-gray-900 text-white text-sm font-semibold hover:bg-black transition-colors duration-200 shadow flex-shrink-0"
            >
                <PlusIcon className="w-4 h-4" />
                Add note
            </button>
        </div>
    );
}

export { NotesHeader };
